require("./scss/mobileindex.scss");

$(function() {
    // $('.gray-box-bar li').click(function(e) {
    //     e.preventDefault();
    //     console.log("点到了",e)
    // })

    // if(window.orientation==90||window.orientation==-90){
    //     　    console.log("横屏状态！")
    // }else if(window.orientation==0||window.orientation==180){
    // 　console.log("竖屏状态！")
    // }
    // var width = document.documentElement.clientWidth;
    // var height = document.documentElement.clientHeight;
    // console.log("width",width)
    // console.log("height",height)

    var bookblock = $('#bb-bookblock');
    function setHeight() {
        var width = window.innerWidth ;
        var height =  window.innerHeight;
        var h = arguments[0]
          ? width
          : height;
        bookblock.height(611*h/750);
        bookblock.css({top: 68*h/750 + 'px'});

    }
    setHeight();
    $(window).resize(function() {
      var width = window.innerWidth ;
      var height =  window.innerHeight;
      setHeight(width<height);
    })

    var width = window.innerWidth ;
    var height =  window.innerHeight;
    $('#J_text').hide().html(width + '----' + height);
    if( width < height ) {//一开始竖屏
        $print =  $('.print');
        $print.width(height);
        $print.height(width);
        $print.css('top',  (height-width)/2 );
        $print.css('left',  0-(height-width)/2 );
        $print.css('transform' , 'rotate(90deg)');
        $print.css('transform-origin' , '50% 50%');
        $print.css('transition' , '100ms linear 100ms');
        setHeight(true);
        setTimeout(function() {
          setHeight(true);
        }, 800);
    }else{//一开始横屏
        $print =  $('.print');
        $print.width(width);
        $print.height(height);
        $print.css('top',  0 );
        $print.css('left',  0 );
        $print.css('transform' , 'none');
        $print.css('transform-origin' , '50% 50%');
        $print.css('transition' , '100ms linear 100ms');

    }

    var evt = "onorientationchange" in window ? "orientationchange" : "resize";
        window.addEventListener(evt, function() {
            window.location.reload();
            return;
            var width = window.innerWidth ;
            var height =  window.innerHeight;
            if(width > height ) {
              $('#shade-suo').show();
              $('#initmodal').show();
            } else {
              $('#shade-suo').hide();
              $('#initmodal').hide();
            }
            //console.log(evt,"evt");
            //  console.log(width + " " + height,"width3")
            //$print =  $('.print');
            //  if( width > height ){
            //       console.log("1111",evt)
            //     $print.width(width);
            //     $print.height(height);
            //     $print.css('top',  0 );
            //     $print.css('left',  0 );
            //     $print.css('transform' , 'rotate(90deg)');
            //     $print.css('transform-origin' , '50% 50%');
            //     $print.css('transition' , '100ms linear 100ms');

            //  }
            //  else{
            //      console.log("22222",evt)
            //     console.log(width + " " + height,"width4")

            //     $print.width(height);
            //     $print.height(width);
            //     // $print.css('top',  0 );
            //     // $print.css('left',  0 );
            //     $print.css('top',  (height-width)/2 );
            //     $print.css('left',  0-(height-width)/2 );
            //     $print.css('transform' , 'none');
            //     $print.css('transform-origin' , '50% 50%');
            //     $print.css('transition' , '100ms linear 100ms');
            //  }
            if(window.orientation==90||window.orientation==-90){
                var width = window.innerWidth;
                var height =  window.innerHeight;
                console.log("横屏状态！")
                console.log(width + " " + height,"width32")
                $print.width(height);
                $print.height(width);
                $print.css('top',  0 );
                $print.css('left',  0 );
                $print.css('transform' , 'none');
                $print.css('transform-origin' , '50% 50%');
                $print.css('transition' , '100ms linear 100ms');
                setHeight(true);
                setTimeout(function() {
                  setHeight(true);
                }, 1000);

            }else if(window.orientation==0||window.orientation==180){
                var width = window.innerWidth;
                var height =  window.innerHeight;
            　  console.log("竖屏状态！")
                console.log(width + " " + height,"width42")
                $print.width(width);
                $print.height(height);
                $print.css('left',  (height-width)/2 );
                $print.css('top',  0-(height-width)/2 );
                $print.css('transform' , 'rotate(90deg)');
                $print.css('transform-origin' , '50% 50%');
                $print.css('transition' , '100ms linear 100ms');
                setHeight();
            }
        }, false)
})



//////////////////
// WEBPACK FOOTER
// ./src/mobileindex.js
// module id = 48
// module chunks = 13